export const AuditLogEndpoints = {
  GET_AUDIT_LOGS: '/api/admin/audit/logs',
  GET_AUDIT_LOG_DETAIL: (id: number) => `/api/admin/audit/logs/${id}`,
};
